import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import ReactPixel from "react-facebook-pixel";
import {GA_ID, PIXEL_ID} from 'shared/constants';
import { Translation } from 'react-i18next';

import {connect} from 'react-redux';
import {resendEmailConfirmation} from 'redux/users/actions';

import Button from 'components/elements/buttons/Button';

import './RegistrationSuccess.css';


class RegistrationSuccess extends Component {
  static propTypes = {
    resendEmailConfirmation: PropTypes.func.isRequired,
    email: PropTypes.string,
    confirmationResentError: PropTypes.object,
  };

  static defaultProps = {
    email: null,
    confirmationResentError: null,
  };

  state = {
    seconds: 20,
  };

  componentDidMount() {
    ReactGA.initialize(GA_ID);
    ReactGA.event({
      category: 'New User',
      action: 'Sign Up',
      label: 'Sign Up Page Form',
    });
    const pixelOptions = {
      autoConfig: true,
      debug: false,
    };
    ReactPixel.init(PIXEL_ID, null, pixelOptions);
    ReactPixel.track('CompleteRegistration');
    // TikTok Pixel Registration event
    if (window.ttq) {
      window.ttq.track('Registration');
    }
    // Yandex Metrika
    if (window.ym) {
      window.ym(69416935, "reachGoal", "SIGNUP");
    }
    // Microsoft Adv UET
    window.uetq = window.uetq || [];
    window.uetq.push('event', 'signup', {});
  }

  render() {
    const {
      resendEmailConfirmation,
      email,
    } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className="registration-success__component">
            <div className="title">
              {t("Welcome to")} <strong>HeyLink.me!</strong>
            </div>
    
            <div className="icon-container">
              <div className="email-icon"/>
            </div>
    
            <div className="user-email">{this.props.email}</div>
    
            <div className="subtext">
              {t("Confirm your email by clicking the verification link we just sent to your inbox")}
            </div>
    
            <div className="buttons-block">
              <Button
                small
                onClick={() => {
                  window.location.href = '/login';
                }}
              >
                <div className="text">
                  {t("Continue to HeyLink.me")}
                </div>
                <div className="icon"/>
              </Button>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    confirmationResentError: state.usersReducer.confirmationResentError,
  }
);

export default connect(
  mapStateToProps,
  {
    resendEmailConfirmation,
  }
)(RegistrationSuccess);
